import { Col, Form, Modal, Row, Spin, Button, App } from 'antd';
import { useEffect, useState } from 'react'
import classes from './report.module.css'  
import dayjs from 'dayjs';
import { useBaozhangdanUpdateQuery,  useTDchaosongMutation, useBaozhangdanZTXGMutation } from '../../store/DianShangYeWuApi';
import IncomeListReport from '../income/IncomeListReport'
import CostListReport from '../cost/CostListReport'
import Copy from '../../cpn/Copy';
import ReportCheckNode from './ReportCheckNode';
import ClientCheck from '../../system/client/ClientCheck';
import ExpenseListReport from '../expense/ExpenseListReport'
import LoanListReport from '../loan/LoanListReport'
import Asterisk from '../../cpn/Asterisk';
import DocumentRule from '../../cpn/DocumentRule';
import ReportCheckNodePendding from './ReportCheckNodePendding';
import StateTag from '../../cpn/StateTag';
import FilePreview from '../../cpn/FilePreview'
import { usePrintModal } from '../../cpn/usePrintModal'
import ReportFinanceWithdraw from './ReportFinanceWithdraw'         
import InvoiceListReport from '../../invoice/invoice/InvoiceListReport'

function ReportCheck(props) {
    const { message } = App.useApp();
    const yh_qx = props.yh_qx || '';
    const [form] = Form.useForm();
    const [openCheck, setOpenCheck] = useState(false)
    const { handlePrint, modalRef } = usePrintModal(openCheck, '团队报账单')
    const [info, setInfo] = useState({
        "dsbzd_content": '',
        "dsbzd_date": dayjs().format('YYYY-MM-DD'),
        "dsbzd_dscp_id": '',
        "dsbzd_dscp_name": '',
        "dsbzd_dspt_id": '',
        "dsbzd_dspt_name": '',
        "dsbzd_jd_id": '',
        "dsbzd_jd_name": '',
        "dsbzd_kf_id": '',
        "dsbzd_kf_name": '',
        "dsbzd_month": '',
        "dsbzd_year": '',
        "dsbzd_zb_id": '',
        "dsbzd_zb_name": '',
        "dsbzd_image_name": '',
        "dsbzd_image_file": '',
        'dsbzd_id': '',
        'dsbzd_state_time':'',
        'dsbzd_state':'',
        'sr_data': [],
        'zc_data': [],
        'fy_data': [],
        'jk_data': [],
        'kpsq_data': [],        
    })

    const { data, isSuccess,isLoading } = useBaozhangdanUpdateQuery({ dsbzd_id: props.dsbzd_id }, { skip: !openCheck, refetchOnMountOrArgChange: 1 })    
    
    const [addChaosong] = useTDchaosongMutation()
    
    useEffect(() => {       
            if(isSuccess){
                if(data.Status==='success' && form){   
                    let mergedElements = []
                    if(data.Result.shenhe_data){
                        mergedElements = data.Result.shenhe_data?.map(item=> item.dsbzdsh_uname + ' ' + item.dsbzdsh_ctime)
                    }                                              
                    setInfo(prevState=>({...prevState,
                        dsbzd_content:data.Result.dsbzd_content,
                        dsbzd_date:data.Result.dsbzd_date,
                        dsbzd_dscp_id:data.Result.dsbzd_dscp_id,
                        dsbzd_dscp_name:data.Result.dsbzd_dscp_name,
                        dsbzd_dspt_id:data.Result.dsbzd_dspt_id,
                        dsbzd_dspt_name:data.Result.dsbzd_dspt_name,  
                        dsbzd_zb_id:data.Result.dsbzd_zb_id,
                        dsbzd_zb_name:data.Result.dsbzd_zb_name,  
                        dsbzd_jd_id:data.Result.dsbzd_jd_id,  
                        dsbzd_jd_name:data.Result.dsbzd_jd_name,  
                        dsbzd_kh_id:data.Result.dsbzd_kh_id,  
                        dsbzd_kh_name:data.Result.dsbzd_kh_name,  
                        dsbzd_kf_name:data.Result.dsbzd_kf_name,  
                        dsbzd_month:data.Result.dsbzd_month,  
                        dsbzd_qy_id:data.Result.dsbzd_qy_id,  
                        dsbzd_year:data.Result.dsbzd_year,                       
                        dsbzd_danhao:data.Result.dsbzd_danhao,  
                        inNum:data.Result.inNum,  
                        outNum:data.Result.outNum,  
                        shenhe_data:data.Result.shenhe_data,  
                        dsbzd_uname:data.Result.dsbzd_uname,  
                        dsbzd_id:data.Result.dsbzd_id,  
                        dsbzd_ctime:data.Result.dsbzd_ctime,
                        mergedElements, 
                        dsbzd_uid:data.Result.dsbzd_uid, 
                        dsbzd_state:data.Result.dsbzd_state, 
                        dsbzd_comments:data.Result.dsbzd_comments, 
                        dsbzd_date_end:data.Result.dsbzd_date_end,
                        dsbzd_name:data.Result.dsbzd_name,
                        dsbzd_bm_name:data.Result.dsbzd_bm_name,
                        dsbzd_bm_id:data.Result.dsbzd_bm_id,
                        dsbzd_yuedu:data.Result.dsbzd_yuedu,
                        dsbzd_state_time:data.Result.dsbzd_state_time,
                        dsbzd_bohui:data.Result.dsbzd_bohui,
                        dsbzd_image_name:data.Result.dsbzd_image_name,
                        dsbzd_image_file:data.Result.dsbzd_image_file,
                        dsbzd_khlxr_name:data.Result.dsbzd_khlxr_name,
                        sr_data:data.Result.sr_data,
                        zc_data:data.Result.zc_data,    
                        fy_data:data.Result.fy_data,
                        jk_data:data.Result.jk_data,
                        kpsq_data:data.Result.kpsq_data,
                        dsbzd_cw_content:data.Result.dsbzd_cw_content,
                    }))
                }else{
                    setInfo({
                        "dsbzd_content" : '',
                        "dsbzd_date" : dayjs().format('YYYY-MM-DD'),
                        "dsbzd_dscp_id" : '',
                        "dsbzd_dscp_name" : '',
                        "dsbzd_dspt_id" : '',
                        "dsbzd_dspt_name" : '',
                        "dsbzd_jd_id" : '',
                        "dsbzd_jd_name" : '',
                        "dsbzd_kh_id" : '',
                        "dsbzd_kh_name" : '',
                        "dsbzd_kf_name" : '',
                        "dsbzd_month" : '',
                        "dsbzd_year" : '',
                        "dsbzd_zb_id" : '',
                        "dsbzd_zb_name" : '',
                        "dsbzd_image_name" : '',
                        "dsbzd_image_file" : '',
                        dsbzd_id:'',
                        shenhe_data:[],
                        dsbzd_uname:'',
                        dsbzd_ctime:'',
                        dsbzd_danhao:'',
                        mergedElements:[],
                        dsbzd_bohui:0,
                        incomeList: [],
                        costList: [],
                        expenseList: []
                        })
                }
            }
        },[data,isSuccess,form])

     
    // 格式化金额显示
    const formatCurrency = (amount) => {
        return `￥${Number(amount).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    };
    //已结束阅读
    const [baozhangdanZTXG] = useBaozhangdanZTXGMutation() 
    return (
        <>
             <a 
                type='check' 
                onClick={() => { 
                    if(props.dsbzd_sp_state==='2' && props.dsbzd_sp_jd_name==='抄送'){
                        addChaosong({
                            'dsbzd_sp_id': props.dsbzd_sp_id,     //抄送节点id
                            'dsbzd_id': props.dsbzd_id,
                            'dsbzd_sp_yh_id': props.dsbzd_sp_yh_id   //抄送人id
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('抄送成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('抄送失败'+res.data.Message)
                            }
                        })
                    }else if(props.dsbzd_state === '5' && props.dsbzd_uid === props.yh_id){
                        baozhangdanZTXG({
                            dsbzd_id:props.dsbzd_id,
                            dsbzd_state: '6',
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('已读标记成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('已读标记失败'+res.data.Message)
                            }
                        })
                    }else{
                        setOpenCheck(true);  
                    }
                }} 
            >
                {(props.dsbzd_sp_state==='2' && props.dsbzd_sp_jd_name==='抄送')&&<span style={{color:"red"}}>未读：</span>}
                {(props.dsbzd_state==='5' && props.dsbzd_uid === props.yh_id && props.listType === 'submitted')&&<span style={{color:"red"}}>未读：</span>}
                {props.dsbzd_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}
                {props.dsbzd_sp_dsbzd_name?props.dsbzd_sp_dsbzd_name:props.dsbzd_name}
            </a>
            <Modal
                open={openCheck}
                onCancel={() => setOpenCheck(false)}
                onOk={() => setOpenCheck(false)}
                width={1330}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        打印
                    </Button>,
                    <Button key="close" onClick={() => setOpenCheck(false)}>
                        关闭
                    </Button>
                ]}
                maskClosable={false}
            >
                <div ref={modalRef}>
                <Modal
                    open={isLoading}
                    footer={null}
                    closable={false}
                    centered
                    width={300}
                    style={{textAlign: 'center', padding: '24px'}}
                >
                    <Spin size="large" />
                    <div style={{marginTop: 16}}>正在加载，请稍后...</div>
                </Modal>                
                <Row>
                    {(info.dsbzd_state === '5' || info.dsbzd_state==='6') && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/reportFinished.png'} alt="团队报账单" width={150} height={150}/>
                    </div>} 
                    <Col span={3}></Col>
                    <Col span={18}><div style={{fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '10px'}}>团队报账单</div></Col>
                    <Col span={3}></Col>
                </Row>
                <Row style={{width:"1280px"}}>
                    {info.dsbzd_state === '5' && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/reportFinished.png'} alt="团队报账单" width={150} height={150}/>
                    </div>} 
                    {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft: '3px solid #000', borderTop: '3px solid #000'}}><Asterisk color='red'/> 团队名称</Col>
                    <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000',padding:'10px 5px'}}>
                        {info.dsbzd_name}
                    </Col>  
                    <Col span={2} className={classes.col_top_label} style={{borderTop: '3px solid #000'}}><Asterisk color='red'/>部门</Col>
                    <Col span={6}  className={classes.col_top_input} style={{borderTop: '3px solid #000'}}>
                            {info.dsbzd_bm_name}
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} style={{borderTop: '3px solid #000'}}>收款单</Col>
                    <Col span={6}  className={classes.col_right_input} style={{borderTop: '3px solid #000',borderRight:"3px solid #000"}}>共{info.sr_data?.length || 0}张，合计{formatCurrency(((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)))}</Col> 
                    {/* 第二行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000',}}><Asterisk color='red'/> 起止日期</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{padding:'10px 5px'}}>
                        {info.dsbzd_date} 至 {info.dsbzd_date_end}，共{dayjs(info.dsbzd_date_end).diff(dayjs(info.dsbzd_date), 'day') + 1}天
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 计调</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.dsbzd_jd_name}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}>付款单</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                       共{info.zc_data?.length || 0}张，合计{formatCurrency(((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0)))}
                    </Col>                    
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft: '3px solid #000',padding:'10px 5px'}}><Asterisk color='red'/> 客户</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <ClientCheck kh_id={info.dsbzd_kh_id} kh_name={info.dsbzd_kh_name} qy_id={props.qy_id} qy_name={props.qy_name} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>
                    <Col span={2} className={classes.col_bottom_label}> 客户部门</Col>            
                    <Col span={6} className={classes.col_bottom_input}>
                    {info.dsbzd_khlxr_name}
                    </Col> 
                    <Col span={2}  className={classes.col_middle_label}>毛收入</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                        {formatCurrency(
                            ((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) -
                            ((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0))
                        )}
                    </Col>      
                    {/* 第四行 */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000',padding:'10px 5px'}}><Asterisk color='red'/> 对接人</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{padding:'10px 5px'}}>
                   {info.dsbzd_dspt_name}
                    </Col>                                    
                    <Col span={2} className={classes.col_middle_label}>备注</Col>            
                    <Col span={6} className={classes.col_middle_input}>
                        <Copy title={info.dsbzd_content} />
                    </Col>  
                    <Col span={2}  className={classes.col_middle_label}>费用单</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>                        
                        共{info.fy_data?.length || 0}张，合计{formatCurrency((info.fy_data || []).reduce((sum, row) => sum + Number(row.fy_amount || 0), 0))}
                    </Col>           
                    {/* 第五行 */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft: '3px solid #000',padding:'10px 5px'}}>附件</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{padding:'10px 20px',justifyContent:'flex-start'}}>
                        <FilePreview 
                            fileNames={info.dsbzd_image_file} 
                            fileUrls={info.dsbzd_image_name} 
                        />
                    </Col>   
                    <Col span={2} className={classes.col_middle_label}>编号/状态</Col>            
                    <Col span={6} className={classes.col_middle_input}>
                        {info.dsbzd_id}&emsp;<StateTag state={info.dsbzd_state} />
                    </Col>  
                    <Col span={2}  className={classes.col_middle_label}>净收入</Col>
                    <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:"3px solid #000"}}>
                    {formatCurrency(
                        ((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) -
                        ((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0)) -
                        ((info.fy_data || []).reduce((sum, row) => sum + Number(row.fy_amount || 0), 0))
                    )}，净收入率 
                    {((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) > 0 ? ((((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) -
                    ((info.zc_data || []).reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0)) -((info.fy_data || []).reduce((sum, row) => sum + Number(row.fy_amount || 0), 0))) /
                    ((info.sr_data || []).reduce((sum, row) => sum + Number(row.ddsr_amount || 0), 0)) * 100).toFixed(2) : 0}%
                    </Col>         
                    {/* 第六行 */}                             
                    <Col span={24} className={classes.bottom_row} >
                        {info.dsbzd_state ==='1' ? <ReportCheckNodePendding 
                             qy_id={props.qy_id} 
                            qy_name={props.qy_name}
                            yh_id={info.dsbzd_uid} 
                            yh_name={info.dsbzd_uname}
                            dsbzd_uid={info.dsbzd_uid} 
                            dsbzd_uname={info.dsbzd_uname}
                            dsbzd_id={props.dsbzd_id}
                            dsbzd_name={info.dsbzd_name}
                            dsbzd_date={info.dsbzd_date}
                            dsbzd_date_end={info.dsbzd_date_end}
                            dsbzd_kh_id={info.dsbzd_kh_id}
                            dsbzd_kh_name={info.dsbzd_kh_name}
                            dsbzd_state_time={info.dsbzd_state_time}
                            dsbzd_ctime={info.dsbzd_ctime}
                        /> : <ReportCheckNode 
                            qy_id={props.qy_id} 
                            qy_name={props.qy_name}
                            yh_id={props.yh_id} 
                            yh_name={props.yh_name}
                            dsbzd_uid={info.dsbzd_uid} 
                            dsbzd_uname={info.dsbzd_uname}
                            dsbzd_id={props.dsbzd_id}
                            dsbzd_name={info.dsbzd_name}
                            dsbzd_date={info.dsbzd_date}
                            dsbzd_date_end={info.dsbzd_date_end}
                            dsbzd_kh_id={info.dsbzd_kh_id}
                            dsbzd_kh_name={info.dsbzd_kh_name}
                            dsbzd_state_time={info.dsbzd_state_time}
                            spjdList={props.spjdList}
                            dsbzd_ctime={info.dsbzd_ctime}
                        />}
                    </Col>                  
                    <Row style={{width:"100%",marginTop:"10px"}}>
                        <Col span={24} style={{display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            {info.dsbzd_cw_content?<span style={{color:'#FF0000'}}>{info.dsbzd_cw_content}</span>:null}
                                
                            {/* {info.dsbzd_state ==='2' ? <ReportWithdraw dsbzd_id={info.dsbzd_id} dsbzd_name={info.dsbzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name}/> : null} */}
                            {yh_qx.includes('管理') ? <ReportFinanceWithdraw dsbzd_id={info.dsbzd_id} dsbzd_name={info.dsbzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name}  dsbzd_cw_content={info.dsbzd_cw_content}/> : null
                        }</Col>
                    </Row>
                </Row>  
                <IncomeListReport
                    sr_data={info.sr_data}
                    qy_id={props.qy_id}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                />
                <CostListReport
                    zc_data={info.zc_data}
                    qy_id={props.qy_id}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                />
                   
                <ExpenseListReport
                    fy_data={info.fy_data}
                    qy_id={props.qy_id}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                />
                   
                <LoanListReport
                    jk_data={info.jk_data}
                    qy_id={props.qy_id}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    qy_name={props.qy_name}
                    dsbzd_date={info.dsbzd_date}
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_name={info.dsbzd_name}
                    dsbzd_id={props.dsbzd_id}
                />
                   
                <InvoiceListReport
                    kpsq_data={info.kpsq_data}
                    qy_id={props.qy_id}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    qy_name={props.qy_name}
                    dsbzd_date={info.dsbzd_date}
                    dsbzd_date_end={info.dsbzd_date_end}
                    dsbzd_bm_id={info.dsbzd_bm_id}
                    dsbzd_bm_name={info.dsbzd_bm_name}
                    dsbzd_id={props.dsbzd_id}
                    dsbzd_dscp_id={info.dsbzd_dscp_id}
                    dsbzd_dscp_name={info.dsbzd_dscp_name}
                    dsbzd_kh_id={info.dsbzd_kh_id}
                    dsbzd_kh_name={info.dsbzd_kh_name}
                    dsbzd_dspt_id={info.dsbzd_dspt_id}
                    dsbzd_dspt_name={info.dsbzd_dspt_name}
                    dsbzd_name={info.dsbzd_name}
                    dsbzd_uid={info.dsbzd_uid}
                    dsbzd_state={info.dsbzd_state}
                />
            </div>
            </Modal>
        </>
    )
}

export default ReportCheck